module.exports = __webpack_public_path__ + "static/media/pw-coins-icon.24bc2841.svg";